module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/particular04-099d574d13ecb5ed007de2b7fe0093de.png";